module.exports = __webpack_public_path__ + "assets/41654fba36f4ee84e107d8ebd99391ea.png";